import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchUserRolePermissions } from '../helpers/CompanyId';
import Footer from '../components/common/Footer';
import Navbar from './Navbar';
import '../styles/Home.css';

const Home1 = () => {

  const [error, setError] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const getUserRolePermissions = async () => {
        try {
            setLoading(true);
            const data = await fetchUserRolePermissions();
            console.log("DD:", data)
            if (data) {
                setPermissions(data || []);

            }
        } catch (err) {
            console.error('Error fetching permissions:', err);
            setError('Failed to fetch user permissions');
        } finally {
            setLoading(false);
        }
    };

    getUserRolePermissions();
}, []); 

 

  const renderLinks = () => {

      return (
        <ul>
         { permissions.includes('c-role') && <li><a href="/createrole">Create Roles</a></li>}
         { permissions.includes('c-admin' || 'c-accountmanager') && <li><a href="/adminregister">Register Users</a></li>}
         { permissions.includes('c-regemployee') && <li><a href="/employeeregister">Register Employees</a></li>}
         { permissions.includes('c-company') && <li><a href="/companysetup">Company Setup</a></li>}
         { permissions.includes('v-company') && <li><a href="/companydetails">Company Info</a></li>}
         { permissions.includes('c-payroll') && <li><a href="/payroleset">Payroll Setup</a></li>}
         { permissions.includes('c-employee') && <li><a href="/employeesetup">Employee Setup</a></li>}
         { permissions.includes('v-employeelist') && <li><a href="/employeelist">Employee List</a></li>}
         { permissions.includes('up-biometric') && <li><a href="/biometric">Biometric Attendance</a></li>}
         { permissions.includes('up-attendance') && <li><a href="/attendance">Attendance</a></li>}
         { permissions.includes('v-validation') && <li><a href="/Validation">Payroll Data</a></li>}
         { permissions.includes('v-employee') && <li><a href="/employeedetails">Profile</a></li>}
         { permissions.includes('c-payslip') && <li><a href="/payslip">Generate Payslips</a></li>}
         { permissions.includes('v-payslip') && <li><a href="/vpayslip">Payslip</a></li>}
        </ul>
         );
    }

 

  return (
    <div>
      <Navbar />
      <div className="page-container">
        <div className="dashboard-box">
          {renderLinks()}
        </div>
        <div className="content-box">
          <h1>Welcome to the HRMS</h1>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home1;

